import React from 'react';

import styles from './styles';

const IconCustom = ({ iconUrl }) => {
  styles.custom.backgroundImage = `url("${iconUrl}")`;
  return <div style={styles.custom} />;
};

IconCustom.propTypes = {
  iconUrl: React.PropTypes.string,
};

IconCustom.defaultProps = {
  iconUrl: '',
};

export default IconCustom;
